import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { DomiraLayout } from './layouts/DomiraLayout';
import { PaelbiLayout } from './layouts/PaelbiLayout';
import DomiraLanding from './pages/DomiraLanding';
import PaelbiHome from './pages/PaelbiHome';
import Eventi from './pages/Eventi';
import VicinoATe from './pages/VicinoATe';
import ArteMusei from './pages/ArteMusei';
import Servizi from './pages/Servizi';
import Esperienze from './pages/Esperienze';
import InfoBnb from './pages/InfoBnb';
import AdminApp from './admin/AdminApp';
import OnboardingApp from './onboarding/OnboardingApp';
import GuestPortalApp from './guest/GuestPortalApp';
import PartnerApp from './partner/PartnerApp';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<DomiraLayout />}>
            <Route path="/" element={<DomiraLanding />} />
          </Route>
          <Route path="/paelbi" element={<PaelbiLayout />}>
            <Route index element={<PaelbiHome />} />
            <Route path="eventi" element={<Eventi />} />
            <Route path="vicino-a-te" element={<VicinoATe />} />
            <Route path="arte-musei" element={<ArteMusei />} />
            <Route path="servizi" element={<Servizi />} />
            <Route path="esperienze" element={<Esperienze />} />
            <Route path="info-bnb" element={<InfoBnb />} />
          </Route>
          <Route path="/s/:slug" element={<PaelbiLayout />}>
            <Route index element={<PaelbiHome />} />
            <Route path="eventi" element={<Eventi />} />
            <Route path="vicino-a-te" element={<VicinoATe />} />
            <Route path="arte-musei" element={<ArteMusei />} />
            <Route path="servizi" element={<Servizi />} />
            <Route path="esperienze" element={<Esperienze />} />
            <Route path="info-bnb" element={<InfoBnb />} />
          </Route>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/onboarding/*" element={<OnboardingApp />} />
          <Route path="/g/:token/*" element={<GuestPortalApp />} />
          <Route path="/partner/*" element={<PartnerApp />} />
        </Routes>
      </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
